import {Component, Prop} from 'vue-property-decorator'
import Vue from 'vue'

@Component({})
class TimeLineHistoryChange extends Vue {
  @Prop({default: '', type: [String]})
  oldValue: string

  @Prop({default: '', type: [String]})
  newValue: string

  @Prop({default: '', type: [String]})
  oldLabel: string

  @Prop({default: '', type: [String]})
  newLabel: string

  constructor() {
    super()
  }
}

export default TimeLineHistoryChange



// WEBPACK FOOTER //
// ./src/containers/block/block-maintenance-detail/components/index.ts